import {Component, OnInit, AfterViewInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {AppConfigService} from '../../Services/app-config.service';
import {DataService} from '../../Services/data.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-onboard',
  templateUrl: './onboard.component.html',
  styleUrls: ['./onboard.component.css'],
  standalone: false
})
export class OnboardComponent implements OnInit, AfterViewInit {

  vm: any = [];

  get totalItems(): number {
    return this.setupStatus.length;
  }

  get completedItems(): number {
    return this.setupStatus.filter((i: any) => i.has_data).length;
  }

  get incompleteItems(): number {
    return this.totalItems - this.completedItems;
  }

  get percentComplete(): number {
    if (this.totalItems === 0) {
      return 0;
    }
    return Math.round((this.completedItems / this.totalItems) * 100);
  }

  get progressBarClass(): string {
    const pct = this.percentComplete;
    if (pct === 100) {
      return 'bg-success';
    }
    if (pct >= 60) {
      return 'bg-info';
    }
    if (pct >= 30) {
      return 'bg-warning';
    }
    return 'bg-danger';
  }

  tierComplete(tier: number): boolean {
    const items = this.setupStatus.filter((i: any) => i.tier === tier);
    return items.length > 0 && items.every((i: any) => i.has_data);
  }

  tierItemCounts(tier: number): { total: number; done: number } {
    const items = this.setupStatus.filter((i: any) => i.tier === tier);
    return {total: items.length, done: items.filter((i: any) => i.has_data).length};
  }

  accountSetup = false;
  companySetup = false;
  locationSetup = false;
  entityTypeSetup = false;
  entitySetup = false;
  checkStockSetup = false;
  currencySetup = false;
  currencyRateSetup = false;
  bankSetup = false;
  paymentTypeSetup = false;
  termsSetup = false;
  reportingFieldsTypeSetup = false;
  reportingFieldsSetup = false;
  taxesSetup = false;
  taxRatesSetup = false;
  uomSetup = false;
  inventoryItemSetup = false;

  darkMode = false;
  setupStatus = [];
  isLoading = true;

  // Map API item names to app routes for setup
  private setupRouteMap: { [key: string]: string } = {
    // tier 0
    currency: '/admin/currency-form',
    entity_type: '/admin/entity-type-form',
    item_category: '/admin/item-category-form',
    item_group: '/admin/item-group-form',
    item_type: '/admin/item-type-form',
    payment_type: '/admin/payment-type-form',
    reporting_field_type: '/admin/reporting-field-type-form',
    tax: '/admin/tax-form',
    term: '/admin/term-form',
    uom: '/admin/uom-form',

    // tier 1
    account_margin: '/admin/account-margin-form',
    account_subtotal: '/admin/account-subtotal-form',
    check_stock: '/admin/check-stock-form',
    location_group: '/admin/location-group-form',

    // tier 2
    company: '/admin/company-form',
    currency_rate: '/admin/currency-rate-form',
    sys_user: '/admin/sys-user-form',

    // tier 3
    account: '/admin/account-form',
    bank: '/admin/bank-form',

    // tier 4
    company_access: '/admin/company-access-form',
    entity_access: '/admin/entity-access-form',
    location: '/admin/location-form',

    // tier 5
    entity: '/entity-form',

    // tier 6
    bill_of_materials: '/inventory/bill-of-materials/bom-form',
    bill_of_materials_costs: '/inventory/bill-of-materials/bom-form',
    bill_of_materials_source: '/inventory/bill-of-materials/bom-form',
    item: '/admin/item-form',
    item_pricing: '/admin/item-pricing-form',
    salesperson: '/admin/salesperson-form'
  };

  constructor(private titleService: Title,
              private appConfig: AppConfigService,
              private tableDataService: DataService,
              private router: Router,
  ) {
  }

  ngOnInit() {

    // TODO testing and need to complete get data to test each item abd set value based on data being reruend or not
    // example - use data.length to set t/f so ui indicates completed or not
    this.accountSetup = true;
    this.bankSetup = true;
    this.taxRatesSetup = true;
    //

    this.getStatusOfOnboard();

    // values are dark or light
    if (this.appConfig.getEffectiveTheme() === 'dark') {
      this.darkMode = true;
    }

  }

  ngAfterViewInit() {
    this.titleService.setTitle($localize`:Onboard - Getting Started @@gettingStarted:Onboard - Getting Started`);
  }

  getStatusOfOnboard() {
    this.isLoading = true;
    this.tableDataService.getData('onboard', '?includeOptional=false').subscribe((result: any) => {
      this.setupStatus = result;
      this.isLoading = false;
    });
  }

  hasSetupRoute(name: string | null | undefined): boolean {
    if (!name) {
      return false;
    }
    return !!this.setupRouteMap[name];
  }

  goToSetup(name: string): void {
    const route = this.setupRouteMap[name];
    if (route) {
      this.router.navigate([route]).then();
    }
  }

}
